import { sendFetch, POST_OPTIONS, GET_OPTIONS, sendSellerFetch } from './base.service';

const BASE_PATH = '/colors';

export const findColorsByCompany = async (company) => {
    return await sendSellerFetch(`${BASE_PATH}/all/company/${company}`, GET_OPTIONS);
}

export const createColor = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editColor = async (body, id) => {
    return await sendFetch(`${BASE_PATH}/edit/${id}`, POST_OPTIONS, body);
}